<template>
  <div id="app">
    <router-view/>
    </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    const oMeta2 = document.getElementsByTagName('meta')[2];
    const oMeta3 = document.getElementsByTagName('meta')[3];
    const oMeta4 = document.getElementsByTagName('meta')[4];
    if(this.$i18n.locale==='en')
    {
       oMeta2.content = "Auto parts, maintenance market, aftermarket, china motor manufacturing factory, China's high-end auto parts manufacturing enterprises, auto parts brand, auto parts export, Japanese cars, American cars, German cars motor parts ";
      oMeta3.content = "Innovation and  pragmatic, pursuit of excellence, BY MOTOR is a world OEM and Aftermarket provider, giving the foremost series of innovative driver visibility merchandise underneath a trusty complete, providing artistic solutions for industrial and recreational vehicle markets. Combined with super R&D strength and equipment level, through strict quality control, BY MOTOR always adheres to the highest standard to produce the best quality. Consultation hotline :0574-83552189";
      oMeta4.content = "BY MOTOR-AUTO PARTS INDUSTRY PROFESSIONAL ENTERPRISE-https://www.nbbinyu.com";
      document.title="BY MOTOR-Auto parts industry professional production enterprises-wiper motor-window lift motor-transfer case motor-headlight motor-motor accessories"
    }else{
      oMeta2.content = "汽车配件,维修市场,售后市场,宁波电机制造工厂,中国高端汽配制造企业,汽车品牌配件,汽车配件出口,日系车美系车德系车电机配件";
      oMeta3.content = "创新务实,追求卓越,滨宇电机作为一家全球OEM和售后市场供应商,致力于为商业市场提供最可靠的高质量产品,为客户提供完美的解决方案。结合超强的研发实力和设备水平，通过严格的质量控制，滨宇电机始终坚持以最高标准生产最佳质量。咨询热线:0574-83552189";
      oMeta4.content = "滨宇电机-专业电机生产企业-https://www.nbbinyu.com";
      document.title="滨宇电机-汽配行业的专业精工生产企业-雨刮电机-摇窗电机-变速箱换挡电机-灯头电机-电机零部件"
    }
  }
}
</script>

<style>

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  body{
    margin: 0;
    padding: 0;
  }
  a{
    text-decoration: none;
    color:#0C3665;
    cursor: pointer;
  }
  .el-carousel__button{
    width:10px !important;
    height:10px !important;
    border-radius: 50% !important;
  }
  .el-carousel__indicator:hover button{
    background-color: #C7000C !important;
  }
  .el-carousel__indicator.is-active button{
    background-color: #C7000C !important;
  }
  .el-carousel__arrow:hover{
    background-color: #C7000C !important;
  }
#app {
  color: #2c3e50;
  height:100vh;
  font-family: 'DIN';
  letter-spacing: 1px;
}
  input{
    font-family: 'DIN';
  }

</style>



// WEBPACK FOOTER //
// src/App.vue